import FormTextInput from 'components/forms/elements/FormTextInput'

const emergencyContact = ({ isOnsiteRegistration, formDisabled }) => [
  {
    id: 'emergencyContactName',
    size: { sm: 12, md: !isOnsiteRegistration ? 12 : 6 },
    field: (
      <FormTextInput
        name="emergencyContactName"
        label="Emergency Contact Name"
        required
        autoComplete="new-emergencyContactName"
        disabled={formDisabled}
      />
    ),
  },
  {
    id: 'emergencyContactPhone',
    size: { sm: 12, md: 6 },
    field: (
      <FormTextInput
        name="emergencyContactPhone"
        label="Emergency Contact Number"
        required
        autoComplete="new-emergencyContactPhone"
        disabled={formDisabled}
        onCut={(e) => e.preventDefault()}
        onCopy={(e) => e.preventDefault()}
        onPaste={(e) => {
          e.preventDefault()
        }}
      />
    ),
  },
  {
    ...(!isOnsiteRegistration && {
      id: 'confirmEmergencyContactPhone',
      size: { sm: 12, md: 6 },
      field: (
        <FormTextInput
          name="confirmEmergencyContactPhone"
          label="Confirm Emergency Contact Number"
          required
          autoComplete="new-confirmEmergencyContactPhone"
          disabled={formDisabled}
          onCut={(e) => e.preventDefault()}
          onCopy={(e) => e.preventDefault()}
          onPaste={(e) => {
            e.preventDefault()
          }}
        />
      ),
    }),
  },
]

export default emergencyContact
